import './overlay.css';
import { CURSOS, totalesDe } from '../config/cursos.js';
import { CATEGORIAS, porSlug, duracionDe, cursosDe } from '../config/certificaciones.js';
// EL CAJÓN DE ACCESO ESTÁ APAGADO, no borrado (14 oct 2026).
//
// Su formulario autentica contra api.zenkai.com.mx (proyecto 62de3e9f…) y el
// panel consulta sandbox.api.zenkai.com.mx (proyecto 69a0096a…): son dos
// servidores distintos, la sesión no se comparte, y el visitante acababa
// escribiendo su contraseña DOS veces para entrar una.
//
// Mientras tanto "Acceder" lleva directo al login del panel. Para revivir el
// cajón: descomentar este import y el bloque marcado abajo, y apuntar
// src/config/auth.js al backend que use el panel —hace falta además que den
// de alta nuestros dominios como plataforma allá, hoy solo está localhost—.
// import { createAcceder } from './acceder.js';

// Las horas de una certificación se calculan, aquí también.
const horasCert = (slug) => duracionDe(porSlug(slug)).horas;

// Header PERSISTENTE del sitio: nav + CTAs, fijo en el viewport para TODA la
// página. Se monta en `.zk` (para heredar los tokens) y queda `position: fixed`.
// Al bajar del tope gana un fondo translúcido para leerse sobre cualquier sección.

// ---------------------------------------------------------------------------
// Megamenú "Cursos y certificaciones" (Claude Design, proyecto dd25dfb7).
// Riel de 9 entradas en tres grupos —los 4 BLOQUES de aprendizaje, las 3
// CERTIFICACIONES y dos extras— y un panel que cambia en dos modos:
//   · modo RUTA: barra de composición + desglose por bloque (certificaciones y
//     el método; es lo que prueba que una certificación cruza los 4 bloques).
//   · modo REJILLA: 6 tarjetas de curso con portada y duración.
// Inglés entra aquí como CUARTO bloque, no como satélite (de ahí "los cuatro
// bloques" del pie del panel).
// ---------------------------------------------------------------------------

const C = { e: '#0981FF', pn: '#1ED1E9', hs: 'rgba(242,245,250,.5)', en: 'rgba(242,245,250,.2)' };
const COVERS = [
  'linear-gradient(140deg,#16223A,#0D131C)', 'linear-gradient(140deg,#12283A,#0A141D)',
  'linear-gradient(140deg,#0F2B33,#0A181D)', 'linear-gradient(140deg,#152738,#0A141D)',
  'linear-gradient(140deg,#18283F,#0C1522)', 'linear-gradient(140deg,#122630,#0A151C)',
];
// El tercer elemento es a dónde lleva la tarjeta. Las que no lo traen NO se
// dibujan como enlace: antes todas salían con href="#", que no es "sin destino"
// sino "salta al principio de la página" —peor que no ser clicable—.
// El CUARTO elemento es una imagen de portada. Si no viene, la tarjeta usa uno
// de los degradados de `COVERS`, que es lo que había antes: así las tarjetas
// que todavía no tienen foto no se ven rotas, solo sobrias.
// Cuántos cursos tiene una ruta. Igual que las horas: sale de los datos. Los
// tres rótulos decían "12 cursos" escrito a mano y siguieron diciéndolo cuando
// Lean Leader bajó a 11 y Process Validation a 8.
const cursosCert = (slug) => cursosDe(porSlug(slug));

const cards = (list) => list.map(([title, meta, href = null, img = null], i) => ({
  title, meta, href, img, cover: COVERS[i % 6],
}));

// LAS PORTADAS DE CATEGORÍA viven en WordPress como el resto de miniaturas.
//
// Van RECORTADAS A LA PROPORCIÓN DE LA TARJETA (504×192 = 252×96 al doble) y en
// WebP, no los originales ni la variante que genera WordPress:
//     originales 16:9 en PNG ..... 8,200 KB
//     variante 768×432 de WP ..... 1,623 KB
//     estas ......................    44 KB
// El ahorro sale de tres sitios: WebP en vez de PNG para foto, las dimensiones
// reales de la tarjeta, y no cargar el tercio de alto que el recorte descarta
// igualmente. Las genera `tools/portadas-categoria.mjs` desde assets/images.
//
// Al venir ya recortadas tampoco hace falta `object-position`: la de Six Sigma
// necesitaba anclaje porque el recorte automático le cortaba la coronilla, y
// ahora esa decisión está horneada en el archivo.
const PORTADA = (f) => `/portada-cat-${f}.webp`;

const BLOQUES = [
  // Especialízate es el único bloque que ya existe: sus cifras y sus tarjetas
  // salen del catálogo. Los otros tres siguen siendo maqueta —cuando se
  // construyan, sus números tienen que salir de datos igual que estos.
  { label: 'Especialízate', count: `${CURSOS.length} cursos`, title: 'Especialízate', tag: 'E · El multiplicador',
    desc: 'Tu base técnica, la que te hace medible. Certificaciones que la industria reconoce.',
    cta: `Ver los ${CURSOS.length} cursos`, href: '/especializate',
    // Las portadas se emparejan por CLAVE de categoría, no por posición: si
    // mañana se añade una categoría a `certificaciones.js`, la tarjeta sale con
    // su degradado y no con la portada de otra.
    cards: cards([
      ...Object.entries(CATEGORIAS).map(([k, v]) => {
        const f = { lean: 'lean-manufacturing', six: 'six-sigma', cal: 'process-validation' }[k];
        return [v.nombre, `${totalesDe(k).cursos} cursos`, v.ruta, f ? PORTADA(f) : null];
      }),
      ['Análisis de Datos para Manufactura', 'Próximamente', null, PORTADA('analisis-de-datos')],
    ]) },
  { label: 'Pensamiento de Negocio', count: '11 cursos', title: 'Pensamiento de Negocio', tag: 'PN · Traduce a impacto',
    desc: 'Ver la operación completa: costo, ROI y la decisión detrás. Para que resuelvas lo que sí le importa a dirección.',
    cta: 'Ver los 11 cursos',
    cards: cards([['Costos y ROI de proyecto', '14 h'], ['Hoshin Kanri', '12 h'], ['Indicadores de negocio', '10 h'], ['Costo de la no calidad', '8 h'], ['Presupuesto y CAPEX', '10 h'], ['Leer estados financieros', '8 h']]) },
  { label: 'Habilidades Suaves', count: '9 cursos', title: 'Habilidades Suaves', tag: 'HS · Te hace visible',
    desc: 'Comunicar, influir y liderar. Sin ellas tu trabajo existe pero nadie lo ve —ni te escuchan en las juntas.',
    cta: 'Ver los 9 cursos',
    cards: cards([['Presentar resultados a dirección', '12 h'], ['Liderazgo en piso', '10 h'], ['Negociación para ingenieros', '8 h'], ['Comunicación escrita técnica', '6 h'], ['Manejo de conflicto', '8 h'], ['Influir sin autoridad', '8 h']]) },
  { label: 'Inglés para Ingenieros', count: '6 niveles', title: 'Inglés para Ingenieros', tag: 'Incluido en tu suscripción',
    desc: 'El inglés que piden las vacantes globales: juntas, reportes y presentar a dirección. No es inglés de escuela.',
    cta: 'Ver el bloque',
    cards: cards([['Juntas y calls técnicas', 'Nivel 1'], ['Vocabulario de manufactura', 'Nivel 2'], ['Reportes y correos', 'Nivel 3'], ['Entrevistas en inglés', 'Nivel 4'], ['Presentar a dirección', 'Nivel 5'], ['Negociación en inglés', 'Nivel 6']]) },
];

const CERTS = [
  { label: 'Lean Leader', count: horasCert('lean-leader'), ruta: true, title: 'Lean Leader', tag: `Ruta de certificación · ${horasCert('lean-leader')} · ${cursosCert('lean-leader')} cursos`,
    desc: 'No basta con dominar Lean. Para certificarte necesitas los cuatro bloques —así es como se lidera de verdad una operación.',
    cta: 'Ver la ruta completa', href: '/certificaciones/lean-leader',
    segments: [
      { name: 'Especialízate', detail: 'Lean Manufacturing · VSM · SMED', meta: '6 cursos · 40 h', pct: 47, color: C.e },
      { name: 'Pensamiento de Negocio', detail: 'Costos y ROI · Hoshin Kanri', meta: '3 cursos · 18 h', pct: 21, color: C.pn },
      { name: 'Habilidades Suaves', detail: 'Liderazgo en piso · Presentar a dirección', meta: '3 cursos · 16 h', pct: 18, color: C.hs },
      { name: 'Inglés para Ingenieros', detail: 'Nivel 3 requerido', meta: '2 niveles · 12 h', pct: 14, color: C.en },
    ] },
  { label: 'Six Sigma Green Belt', count: horasCert('six-sigma-green-belt'), ruta: true, title: 'Six Sigma Green Belt', tag: `Ruta de certificación · ${horasCert('six-sigma-green-belt')} · ${cursosCert('six-sigma-green-belt')} cursos`,
    desc: 'Cuando el problema es la variación, la intuición no alcanza. De la estadística descriptiva al control estadístico de proceso.',
    cta: 'Ver la ruta completa', href: '/certificaciones/six-sigma-green-belt',
    segments: [
      { name: 'Especialízate', detail: 'Green Belt · MSA · SPC · Minitab', meta: '7 cursos · 44 h', pct: 56, color: C.e },
      { name: 'Pensamiento de Negocio', detail: 'Costos y ROI de proyecto', meta: '2 cursos · 12 h', pct: 15, color: C.pn },
      { name: 'Habilidades Suaves', detail: 'Presentar resultados a dirección', meta: '2 cursos · 14 h', pct: 18, color: C.hs },
      { name: 'Inglés para Ingenieros', detail: 'Nivel 2 requerido', meta: '1 nivel · 8 h', pct: 11, color: C.en },
    ] },
  // Esta entrada decía "Ingeniería de Calidad · 70 h" y no llevaba a ningún
  // lado: era maqueta. Ingeniería de Calidad es una CATEGORÍA; la certificación
  // que sale de ella se llama Validación de Procesos y son 40 h 44 min
  // calculadas. Aparecía como cuarta certificación inexistente en el menú de
  // todo el sitio.
  { label: 'Process Validation', count: horasCert('validacion-de-procesos'), ruta: true,
    title: 'Process Validation', tag: `Ruta de certificación · ${horasCert('validacion-de-procesos')} · ${cursosCert('validacion-de-procesos')} cursos`,
    desc: 'Calidad se defiende ante auditoría y ante dirección. Por eso la ruta cruza los cuatro bloques.',
    cta: 'Ver la ruta completa', href: '/certificaciones/validacion-de-procesos',
    segments: [
      { name: 'Especialízate', detail: 'IQ/OQ/PQ · TMV · pFMEA · Minitab', meta: `${cursosCert('validacion-de-procesos')} cursos`, pct: 54, color: C.e },
      { name: 'Pensamiento de Negocio', detail: 'Costo de la no calidad', meta: '2 cursos · 12 h', pct: 17, color: C.pn },
      { name: 'Habilidades Suaves', detail: 'Negociación · Comunicar hallazgos', meta: '2 cursos · 12 h', pct: 17, color: C.hs },
      { name: 'Inglés para Ingenieros', detail: 'Nivel 3 requerido', meta: '2 niveles · 8 h', pct: 12, color: C.en },
    ] },
];

const EXTRAS = [
  { label: 'Sesiones en vivo', count: 'Cada 2 semanas', title: 'Sesiones en vivo', tag: 'EN VIVO', live: true,
    desc: 'Llevas tu caso real y lo resuelves con expertos en activo. Cada dos semanas, sobre los 4 ejes —no es video grabado.',
    cta: 'Ver el calendario', href: '/en-vivo',   // única entrada con página propia (por ahora)
    // TRES, no seis. Las otras tres eran títulos inventados; estas son las
    // sesiones que existen de verdad, con la portada que entregó Julio. Cuando
    // haya más, se agregan aquí con su imagen y la rejilla crece sola.
    // El horario NO se pone: no lo tenemos, y escribir uno falso en una tarjeta
    // que promete una cadencia es justo el dato que alguien vendría a cobrar.
    cards: cards([
      ['Asesoría: Problem Solving', 'Asesoría', null, '/portada-vivo-problem-solving.webp'],
      ['Cómo entregar resultados con Six Sigma', 'Asesoría', null, '/portada-vivo-resultados-six-sigma.webp'],
      ['Cómo debe un ingeniero hacer un presupuesto', 'Sesión', null, '/portada-vivo-presupuesto.webp'],
    ]) },
  { label: 'El método de los 4 ejes', count: 'Cómo funciona', ruta: true, title: 'El método de los 4 ejes', tag: 'E × (PN + HS)³⁶⁵',
    desc: 'Por qué los bloques están organizados así —y por qué toda certificación los cruza.',
    cta: 'Conoce el método',
    segments: [
      { name: 'E · Especialízate', detail: 'El multiplicador: si vale 0, todo se multiplica por 0', meta: 'afuera', pct: 40, color: C.e },
      { name: 'PN · Pensamiento de Negocio', detail: 'Traduce tu trabajo a impacto que dirección entiende', meta: 'suma', pct: 22, color: C.pn },
      { name: 'HS · Habilidades Suaves', detail: 'Te hace visible: comunicar, influir, liderar', meta: 'suma', pct: 22, color: C.hs },
      { name: '³⁶⁵ · Todos los días', detail: 'La constancia es el exponente. Eso es kaizen', meta: 'exponente', pct: 16, color: C.en },
    ] },
];

// OCULTOS DE MOMENTO — no borrados.
//
// Pensamiento de Negocio y Habilidades Suaves salen del riel del megamenú hasta
// que sus cursos existan. Sus fichas de arriba se quedan enteras: el día que se
// construyan, se saca su nombre de este conjunto y vuelven solos, con sus
// tarjetas y su panel intactos. Borrarlas habría significado reescribirlas.
//
// Se filtra AQUÍ, en un solo sitio, y `ALL` se arma del resultado. Las filas se
// numeran con un contador corrido y el panel se busca por ese índice, así que
// esconder una fila sin sacarla de `ALL` desalinearía todo: al abrir una
// certificación saldría el panel de otra cosa.
const OCULTOS = new Set(['Pensamiento de Negocio', 'Habilidades Suaves', 'Inglés para Ingenieros']);
const visible = (lista) => lista.filter((it) => !OCULTOS.has(it.label));

const BLOQUES_VIS = visible(BLOQUES);
const ALL = [...BLOQUES_VIS, ...CERTS, ...EXTRAS];

// RUTA DEL LIBRO. En una constante porque la usan el nav de escritorio y el
// cajón móvil, y una ruta repetida a mano es una que se queda a medio cambiar.
// Las pantallas de cuenta viven en el panel. Comprobadas una por una el 14
// oct 2026 renderizándolas: el panel es una SPA con comodín y responde 200 a
// cualquier ruta, así que el código de estado no sirve para validarlas.
// `?step=plan` abre el registro en la selección de plan, que es el primer
// paso de su flujo.
const AUTH = {
  login: 'https://panel.zenkai.com.mx/auth/login',
  signup: 'https://panel.zenkai.com.mx/auth/sign-up?step=plan',
  forgot: 'https://panel.zenkai.com.mx/auth/password-recovery',
};

const RUTA_LIBRO = '/libros';

// Los dos del desplegable "Inge Chingón": micrófono para el podcast, libro
// abierto para los libros. Vienen del diseño con sus colores —azul la acción,
// cian lo editorial—, que es la misma pareja que usa el resto del sitio.
const IC_MIC = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#0981FF" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M19 10a7 7 0 0 1-14 0"/><path d="M12 17v5"/></svg>';
const IC_LIBRO = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1ED1E9" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 4h6a4 4 0 0 1 4 4v13a3 3 0 0 0-3-3H2z"/><path d="M22 4h-6a4 4 0 0 0-4 4v13a3 3 0 0 1 3-3h7z"/></svg>';

const CHEV = `<svg class="zk-mega__chev" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>`;
const CHEV_R = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5A6473" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>`;
const CHEV_L = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>`;
const BURGER = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true"><path d="M4 7h16M4 12h16M4 17h16"/></svg>`;
const CLOSE_X = `<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>`;
const ARROW = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h14M13 6l6 6-6 6"/></svg>`;

// Las entradas que YA tienen página son enlaces (pasar el cursor previsualiza,
// hacer clic navega); las que aún no la tienen se quedan como botón, que solo
// cambia el panel. Conforme se construyan las páginas, todas serán enlaces.
const rowHTML = (it, i) => {
  const inner = `<span class="zk-mega__row-label">${it.label}</span><span class="zk-mega__row-count">${it.count}</span>`;
  const cls = `zk-mega__row${i === 0 ? ' is-active' : ''}`;
  return it.href
    ? `<a class="${cls}" data-i="${i}" href="${it.href}">${inner}</a>`
    : `<button type="button" class="${cls}" data-i="${i}">${inner}</button>`;
};

function megaHTML() {
  let i = 0;
  const bloques = BLOQUES_VIS.map((it) => rowHTML(it, i++)).join('');
  const certs = CERTS.map((it) => rowHTML(it, i++)).join('');
  const extras = EXTRAS.map((it) => rowHTML(it, i++)).join('');
  return `
    <div class="zk-mega" data-mega>
      <button type="button" class="zk-mega__trigger" aria-expanded="false" aria-haspopup="true">Cursos y certificaciones${CHEV}</button>
      <div class="zk-mega__panel">
        <div class="zk-mega__rail" aria-label="Cursos y certificaciones">
          <div class="zk-mega__rail-label">Los 4 ejes</div>
          ${bloques}
          <div class="zk-mega__rail-div"></div>
          <div class="zk-mega__rail-label">Certificaciones</div>
          ${certs}
          <div class="zk-mega__rail-div"></div>
          ${extras}
        </div>
        <div class="zk-mega__stage" data-parity="a"></div>
      </div>
    </div>`;
}

// El panel se re-pinta al cambiar de entrada. Las animaciones se reinician
// alternando el nombre del keyframe (truco del diseño): con data-parity a/b el
// navegador ve una animación distinta y la vuelve a correr sin forzar reflow.
function stageHTML(cur) {
  const tag = cur.live
    ? `<span class="zk-mega__tag zk-mega__tag--live">${cur.tag}</span>`
    : `<span class="zk-mega__tag">${cur.tag}</span>`;

  const body = cur.ruta
    ? `<div class="zk-mega__ruta">
        <div class="zk-mega__bar">
          ${cur.segments.map((s, i) => `<div class="zk-mega__bar-seg" style="flex:${s.pct} 1 0;background:${s.color};animation-delay:${90 + i * 70}ms"></div>`).join('')}
        </div>
        ${cur.segments.map((s, i) => `
          <div class="zk-mega__seg" style="animation-delay:${140 + i * 60}ms">
            <span class="zk-mega__seg-dot" style="background:${s.color}"></span>
            <span class="zk-mega__seg-txt">
              <span class="n">${s.name}</span>
              <span class="d">${s.detail}</span>
            </span>
            <span class="zk-mega__seg-meta">${s.meta}</span>
          </div>`).join('')}
      </div>`
    : `<div class="zk-mega__cards">
        ${cur.cards.map((c, i) => {
          const attrs = `class="zk-mega__card${c.href ? '' : ' is-flat'}" style="animation-delay:${90 + i * 40}ms"`;
          // `loading="lazy"`: el megamenú está cerrado al cargar la página, así que
          // sus portadas no deben competir con el hero por el ancho de banda.
          const dentro = `
            <span class="zk-mega__card-cover" style="background:${c.cover}">
              ${c.img ? `<img class="zk-mega__card-img" src="${c.img}" alt="" loading="lazy" decoding="async" />` : ''}
              <span class="zk-mega__card-meta">${c.meta}</span></span>
            <span class="zk-mega__card-title">${c.title}</span>`;
          return c.href ? `<a ${attrs} href="${c.href}">${dentro}</a>` : `<div ${attrs}>${dentro}</div>`;
        }).join('')}
      </div>`;

  return `
    <div class="zk-mega__head">
      <span class="zk-mega__title">${cur.title}</span>
      ${tag}
    </div>
    <p class="zk-mega__desc">${cur.desc}</p>
    ${body}
    <div class="zk-mega__foot">
      ${cur.href
        ? `<a class="zk-mega__cta" href="${cur.href}">${cur.cta}${ARROW}</a>`
        : `<span class="zk-mega__cta" aria-disabled="true">${cur.cta}${ARROW}</span>`}
      <!-- La página de El Método Zenkai no existe todavía; hasta que exista,
           esto no es un enlace (ver la nota del CTA de arriba).
           El texto ya no dice "los cuatro bloques": con dos ocultos el riel
           enseña dos, y prometer cuatro en el pie del mismo panel se lee como
           un error. Se cuenta desde los bloques VISIBLES, así que si vuelven,
           el pie vuelve solo. -->
      <span class="zk-mega__all" aria-disabled="true">${BLOQUES_VIS.length === BLOQUES.length ? 'Ver los cuatro bloques' : 'Ver el método completo'}</span>
    </div>`;
}

// ---------------------------------------------------------------------------
// Versión MÓVIL: el megamenú de dos columnas no cabe, así que se convierte en un
// cajón de DOS NIVELES. Nivel 1: la lista completa (los tres grupos + los enlaces
// sueltos del header, que en móvil no tienen dónde vivir). Nivel 2: el detalle de
// la entrada elegida, con el CTA fijo abajo. Las filas miden 56px de alto —por
// encima del mínimo táctil de 44px.
// ---------------------------------------------------------------------------
const drawerRow = (it, i) => `
  <button type="button" class="zk-drawer__row" data-i="${i}">
    <span class="zk-drawer__row-txt">
      <span class="l">${it.label}</span>
      <span class="c">${it.count}</span>
    </span>${CHEV_R}
  </button>`;

function drawerListHTML() {
  let i = 0;
  const bloques = BLOQUES_VIS.map((it) => drawerRow(it, i++)).join('');
  const certs = CERTS.map((it) => drawerRow(it, i++)).join('');
  const extras = EXTRAS.map((it) => drawerRow(it, i++)).join('');
  return `
    <div class="zk-drawer__group">Los 4 ejes</div>
    ${bloques}
    <div class="zk-drawer__div"></div>
    <div class="zk-drawer__group">Certificaciones</div>
    ${certs}
    <div class="zk-drawer__div"></div>
    ${extras}
    <div class="zk-drawer__div"></div>
    <div class="zk-drawer__links">
      <!-- En móvil NO se anida un desplegable dentro del cajón: ya es una
           lista vertical, y meter otro nivel solo añade un toque para llegar
           a lo mismo. Los dos van sueltos. -->
      <a href="/#podcast">Podcast</a>
      <a href="${RUTA_LIBRO}">Libros</a>
      <a href="/empresas">Empresas</a>
      <a class="zk-drawer__acceder" href="${AUTH.login}">Acceder</a>
    </div>`;
}

function drawerDetailHTML(cur) {
  const tag = cur.live
    ? `<span class="zk-drawer__tag zk-drawer__tag--live">${cur.tag}</span>`
    : `<span class="zk-drawer__tag">${cur.tag}</span>`;
  const body = cur.ruta
    ? `<div class="zk-drawer__bar">
        ${cur.segments.map((s) => `<div style="flex:${s.pct} 1 0;background:${s.color};height:100%"></div>`).join('')}
      </div>
      ${cur.segments.map((s) => `
        <div class="zk-drawer__seg">
          <span class="zk-drawer__seg-dot" style="background:${s.color}"></span>
          <span class="zk-drawer__seg-txt">
            <span class="n">${s.name}</span>
            <span class="d">${s.detail}</span>
            <span class="m">${s.meta}</span>
          </span>
        </div>`).join('')}`
    : `<div class="zk-drawer__cards">
        ${cur.cards.map((c) => {
          // Mismo criterio que en escritorio: la tarjeta con destino es enlace;
          // la que no, se queda como bloque. En móvil estas tarjetas NUNCA
          // fueron clicables —ni siquiera con href muerto—, así que las tres
          // categorías tampoco llevaban a su página desde el menú.
          const dentro = `
            <span class="zk-drawer__card-cover" style="background:${c.cover}"></span>
            <span class="zk-drawer__card-txt">
              <span class="t">${c.title}</span>
              <span class="m">${c.meta}</span>
            </span>`;
          return c.href
            ? `<a class="zk-drawer__card" href="${c.href}">${dentro}</a>`
            : `<div class="zk-drawer__card">${dentro}</div>`;
        }).join('')}
      </div>`;
  return `
    <button type="button" class="zk-drawer__back">${CHEV_L}Cursos y certificaciones</button>
    <div class="zk-drawer__scroll">
      <div class="zk-drawer__title">${cur.title}</div>
      ${tag}
      <p class="zk-drawer__desc">${cur.desc}</p>
      ${body}
    </div>
    <div class="zk-drawer__foot">
      ${cur.href
        ? `<a class="zk-drawer__cta" href="${cur.href}">${cur.cta}${ARROW}</a>`
        : `<span class="zk-drawer__cta" aria-disabled="true">${cur.cta}${ARROW}</span>`}
    </div>`;
}

export function createHeader(mount) {
  // RETIRAR LO PRERENDERIZADO. El build deja el contenido ya pintado dentro
  // del HTML (tools/prerender.mjs) para que lo vean los buscadores y quien
  // llegue sin JavaScript. Al arrancar, el cliente vuelve a montarlo todo —así
  // que si no se quita lo de antes, la página sale DUPLICADA.
  //
  // Va aquí y no en cada página porque las 54 llaman a createHeader como
  // primera instrucción: un solo lugar en vez de cincuenta que se desincronizan.
  document.querySelectorAll('[data-pre]').forEach((n) => n.remove());

  const bar = document.createElement('header');
  bar.className = 'zk-topbar';
  bar.innerHTML = `
    <a class="zk-topbar__brand" href="/" aria-label="Zenkai — ir al inicio">
      <img src="/zenkai-logo-blanco.webp" alt="Zenkai" width="2550" height="860" />
    </a>
    <nav class="zk-topbar__nav">
      ${megaHTML()}
      <!-- INGE CHINGÓN agrupa el podcast y los libros. Antes "Podcast" era un
           enlace suelto; ahora los dos cuelgan de la marca de Julio, que es lo
           que de verdad comparten. El menú gana un SEGUNDO desplegable, así que
           este lleva el mismo trato que el de cursos: botón con aria-expanded,
           cierre con Escape y con clic fuera. -->
      <div class="zk-ic">
        <button type="button" class="zk-ic__trigger" aria-expanded="false" aria-haspopup="true">Inge Chingón${CHEV}</button>
        <div class="zk-ic__panel">
          <!-- La caja de cristal es un HIJO del panel: el panel incluye un
               puente transparente de 8px entre el botón y el menú, y pintar
               el fondo ahí dejaría una franja de cristal flotando. -->
          <div class="zk-ic__caja">
          <!-- Rutas absolutas, no anclas sueltas: el header es compartido y
               desde otra página "#podcast" no lleva a ningún lado. -->
          <a href="/#podcast">
            <span class="zk-ic__ico zk-ic__ico--pod">${IC_MIC}</span>
            <span><span class="t">Podcast</span><span class="d">Conversaciones con quienes ya llegaron</span></span>
          </a>
          <a href="${RUTA_LIBRO}">
            <span class="zk-ic__ico zk-ic__ico--lib">${IC_LIBRO}</span>
            <span><span class="t">Libros</span><span class="d">Conviértete en Inge Chingón</span></span>
          </a>
          </div>
        </div>
      </div>
    </nav>
    <div class="zk-topbar__cta">
      <!-- Empresas (B2B) es otra AUDIENCIA, no otro producto: va en la zona
           secundaria para no competir con el nav. -->
      <a class="zk-topbar__biz" href="/empresas">Empresas</a>
      <!-- UN solo CTA. Antes había dos —"Iniciar sesión" y "Suscríbete"— que
           competían entre sí en el mismo rincón y obligaban al visitante a
           decidir su estado de cuenta antes de saber a dónde iba. Ahora entra
           por "Acceder" y adentro elige. -->
      <a class="zk-btn zk-btn--solid zk-topbar__acceder" href="${AUTH.login}">Acceder</a>
      <button type="button" class="zk-burger" aria-label="Menú" aria-expanded="false">${BURGER}</button>
    </div>`;
  const host = mount || document.body;
  host.appendChild(bar);

  // Cajón móvil: hermano de la barra, para quedar bajo ella y sobre la página.
  const drawer = document.createElement('div');
  drawer.className = 'zk-drawer';
  drawer.dataset.open = 'false';
  drawer.dataset.level = 'list';
  drawer.innerHTML = `<div class="zk-drawer__list">${drawerListHTML()}</div><div class="zk-drawer__detail" data-parity="a"></div>`;
  host.appendChild(drawer);

  // Velo: mientras el megamenú está abierto, lo que hay DEBAJO se difumina para
  // que el panel no compita con el 3D del hero. Va como hermano de la barra (no
  // dentro), para quedar por encima de la página pero por debajo del header —
  // así la barra y el panel se leen nítidos y solo el fondo se esmerila.
  const veil = document.createElement('div');
  veil.className = 'zk-veil';
  veil.setAttribute('aria-hidden', 'true');
  host.appendChild(veil);

  const onScroll = () => bar.classList.toggle('is-scrolled', window.scrollY > 40);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  bindMega(bar, veil);
  bindIngeChingon(bar);
  bindDrawer(bar, drawer);

  // El cajón de acceso se monta UNA vez y lo comparten los dos puntos de
  // entrada: el botón del header y el enlace del menú móvil. Al abrirlo desde
  // móvil hay que cerrar antes el cajón de navegación, o quedarían dos paneles
  // encima uno del otro.
  // Los dos "Acceder" son enlaces al panel, no disparadores del cajón, así que
  // no llevan atadura. El del cajón de navegación sí lo cierra al salir: si no,
  // al volver con el botón atrás del navegador se encontraría el menú abierto.
  const burger = bar.querySelector('.zk-burger');
  drawer.querySelector('.zk-drawer__acceder').addEventListener('click', () => {
    drawer.dataset.open = 'false';
    burger?.setAttribute('aria-expanded', 'false');
  });

  // --- Para revivir el cajón: descomentar esto y el import de arriba. --------
  // const acceder = createAcceder(host);
  // const btnAcceder = bar.querySelector('.zk-topbar__acceder');
  // btnAcceder.addEventListener('click', (e) => { e.preventDefault(); acceder.abrir('login', btnAcceder); });

  return bar;
}

function bindDrawer(bar, drawer) {
  const burger = bar.querySelector('.zk-burger');
  const detail = drawer.querySelector('.zk-drawer__detail');
  const rows = [...drawer.querySelectorAll('.zk-drawer__row')];

  const setOpen = (on) => {
    drawer.dataset.open = String(on);
    burger.setAttribute('aria-expanded', String(on));
    burger.innerHTML = on ? CLOSE_X : BURGER;
    // El cajón arranca justo debajo de la barra, medida en vivo (su alto cambia
    // con el padding responsive), y se bloquea el scroll del documento detrás.
    if (on) drawer.style.paddingTop = `${bar.offsetHeight}px`;
    document.documentElement.style.overflow = on ? 'hidden' : '';
    if (!on) drawer.dataset.level = 'list';
  };

  burger.addEventListener('click', () => setOpen(drawer.dataset.open !== 'true'));
  rows.forEach((r, i) => r.addEventListener('click', () => {
    detail.dataset.parity = i % 2 ? 'b' : 'a';   // reinicia la animación de empuje
    detail.innerHTML = drawerDetailHTML(ALL[i]);
    detail.querySelector('.zk-drawer__back').addEventListener('click', () => { drawer.dataset.level = 'list'; });
    drawer.dataset.level = 'detail';
    drawer.querySelector('.zk-drawer__scroll').scrollTop = 0;
  }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.dataset.open === 'true') setOpen(false); });
  // Al pasar a escritorio el cajón deja de aplicar: se cierra para no dejar el
  // scroll del documento bloqueado.
  window.matchMedia('(min-width: 1101px)').addEventListener('change', (e) => { if (e.matches) setOpen(false); });
}

function bindMega(bar, veil) {
  const mega = bar.querySelector('[data-mega]');
  if (!mega) return;
  const trigger = mega.querySelector('.zk-mega__trigger');
  const rows = [...mega.querySelectorAll('.zk-mega__row')];
  const stage = mega.querySelector('.zk-mega__stage');
  let closeT = 0;
  let openT = 0;
  let current = -1;

  const select = (i) => {
    if (i === current) return;
    rows.forEach((r, k) => r.classList.toggle('is-active', k === i));
    stage.dataset.parity = i % 2 ? 'b' : 'a';   // reinicia las animaciones
    stage.innerHTML = stageHTML(ALL[i]);
    current = i;
  };

  const open = () => {
    clearTimeout(closeT);
    mega.classList.add('is-open');
    if (veil) veil.classList.add('is-on');
    trigger.setAttribute('aria-expanded', 'true');
  };
  const close = () => {
    clearTimeout(openT);
    mega.classList.remove('is-open');
    if (veil) veil.classList.remove('is-on');
    trigger.setAttribute('aria-expanded', 'false');
  };

  mega.addEventListener('pointerenter', () => { openT = setTimeout(open, 70); });
  mega.addEventListener('pointerleave', () => { clearTimeout(openT); closeT = setTimeout(close, 220); });
  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    mega.classList.contains('is-open') ? close() : open();
  });
  rows.forEach((r, i) => {
    r.addEventListener('pointerenter', () => select(i));
    r.addEventListener('focus', () => { open(); select(i); });
    r.addEventListener('click', () => select(i));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  document.addEventListener('click', (e) => { if (!mega.contains(e.target)) close(); });

  select(0);

}

/**
 * El desplegable "Inge Chingón" del nav: agrupa Podcast y Libros.
 *
 * Va aparte de `bindMega` y no dentro: aquella sale antes con un `return` si
 * no encuentra el megamenú, y entonces este desplegable se quedaría muerto por
 * un motivo que no tiene nada que ver con él.
 *
 * Mismo contrato que el megamenú —apuntar y pulsar abren, Escape y clic fuera
 * cierran, el botón dice su estado con `aria-expanded`— porque dos
 * desplegables de la misma barra comportándose distinto es de esas cosas que
 * nadie sabe nombrar pero todo el mundo nota.
 */
function bindIngeChingon(bar) {
  const ic = bar.querySelector(".zk-ic");
  if (!ic) return;
  const btn = ic.querySelector(".zk-ic__trigger");
  const mega = bar.querySelector("[data-mega]");
  let t = 0;
  const set = (on) => {
    clearTimeout(t);
    ic.classList.toggle("is-open", on);
    btn.setAttribute("aria-expanded", String(on));
  };
  ic.addEventListener("pointerenter", () => {
    set(true);
    // Abrir uno cierra el otro: en esta barra los dos paneles se solapan.
    mega?.classList.remove("is-open");
  });
  // El retardo al salir es el mismo del megamenú: sin él, el hueco entre el
  // botón y el panel cierra el menú a medio camino hacia un enlace.
  ic.addEventListener("pointerleave", () => { clearTimeout(t); t = setTimeout(() => set(false), 220); });
  btn.addEventListener("click", (e) => { e.preventDefault(); set(!ic.classList.contains("is-open")); });
  // Al salir del último enlace con Tab se cierra solo: si no, queda abierto sin
  // foco dentro, tapando lo que el visitante acaba de enfocar.
  ic.addEventListener("focusout", (e) => { if (!ic.contains(e.relatedTarget)) set(false); });
  mega?.addEventListener("pointerenter", () => set(false));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") set(false); });
  document.addEventListener("click", (e) => { if (!ic.contains(e.target)) set(false); });
}
